import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/i18n';

interface LanguageSwitcherProps {
  className?: string;
  variant?: 'menu' | 'inline';
}

const LABEL_KEY: Record<SupportedLanguage, string> = {
  en: 'language.english',
  de: 'language.german',
};

export function LanguageSwitcher({ className, variant = 'menu' }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation();
  const current = (i18n.language.split('-')[0] as SupportedLanguage) || 'en';

  if (variant === 'inline') {
    return (
      <div className={className}>
        {SUPPORTED_LANGUAGES.map((lng) => (
          <button
            key={lng}
            type="button"
            onClick={() => i18n.changeLanguage(lng)}
            className={
              lng === current
                ? 'px-2 py-1 text-xs font-semibold text-primary'
                : 'px-2 py-1 text-xs text-on-surface-variant hover:text-brand-dark'
            }
          >
            {lng.toUpperCase()}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="px-3 py-1 text-[10px] uppercase tracking-wider text-on-surface-variant">
        {t('language.label')}
      </div>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          onClick={() => i18n.changeLanguage(lng)}
          className={
            'w-full flex items-center justify-between gap-3 px-3 py-2 hover:bg-surface-container-low rounded-xl text-sm ' +
            (lng === current ? 'text-primary font-semibold' : 'text-brand-dark')
          }
        >
          <span>{t(LABEL_KEY[lng])}</span>
          {lng === current && <span className="material-symbols-outlined text-base">check</span>}
        </button>
      ))}
    </div>
  );
}
